import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { TravelQuiz } from './travel-quiz'

interface QuizModalProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onComplete: () => void
}

/**
 * VOY-358: Dialog wrapper around the existing 5-step TravelQuiz wizard.
 * The wizard's `onComplete` now closes the modal and asks the orchestrator
 * to re-fetch profile data so the Traveler DNA sidebar card reflects the
 * new quiz result immediately.
 */
export function QuizModal({ isOpen, onOpenChange, onComplete }: QuizModalProps) {
  const handleComplete = () => {
    onComplete()
    onOpenChange(false)
  }

  const handleCancel = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Travel personality quiz</DialogTitle>
          <DialogDescription>
            Answer a few quick questions so our AI agents can match you to the right trips.
          </DialogDescription>
        </DialogHeader>
        <TravelQuiz onComplete={handleComplete} onCancel={handleCancel} />
      </DialogContent>
    </Dialog>
  )
}
